import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Acquiring icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Acquiring } from '@sravni/design-system-icons'
 *
 * <Acquiring />
 * ```
 */
var Acquiring = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Acquiring", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.437 7.5h-3.54a.834.834 0 0 1-.834-.833V5c0-.46.374-.833.834-.833h3.54c.46 0 .833.373.833.833v1.667c0 .46-.373.833-.833.833ZM14.167 5.272c.61.61.61 1.599 0 2.21M16.745 4.167a3.125 3.125 0 0 1 0 4.419M15 18.333H7.5a.834.834 0 0 1-.833-.833v-4.167c0-.46.373-.833.833-.833H15c.46 0 .833.373.833.833V17.5c0 .46-.373.833-.833.833Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M11.667 12.5V3.333c0-.92-.746-1.666-1.667-1.666H3.333c-.92 0-1.666.746-1.666 1.666v10c0 .921.745 1.667 1.666 1.667h3.334M6.667 15h9.166", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.167 9.992c-.003 0-.005.001-.005.004 0 .002.002.004.005.004.002 0 .004-.002.004-.004 0-.003-.002-.004-.004-.004ZM6.667 10c-.003 0-.005.002-.005.004 0 .003.002.004.005.004.002 0 .004-.001.004-.004 0-.002-.002-.004-.004-.004ZM9.17 9.996c-.002 0-.003.002-.003.004s.001.004.004.004c.002 0 .004-.002.004-.004s-.002-.004-.004-.004Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Acquiring };
//# sourceMappingURL=Acquiring.js.map
